import { useApi } from '../composables'
import http from '../composables/src/useHttp'

export const deleteUser = (id: string) => {
  return useApi(http.delete(`/users/${id}`))
}
export const createContact = (data: any) => {
  return useApi(http.post(`/contacts`, data))
}
export const updateContact = (id: string, data: any) => {
  return useApi(http.patch(`/contacts/${id}`, data))
}
export const createUser = (data: any) => {
  return useApi(http.post(`/users`, data))
}
export const removeUser = (id: string) => {
  return useApi(http.delete(`/users/${id}`))
}
export const updateUser = (id: string, data: any) => {
  return useApi(http.patch(`/users/${id}`, data))
}
export const getUser = (id: string) => {
  return useApi(http.get(`/users/${id}`))
}
export const fetchContacts = (searchQuery: string) => {
  return useApi(http.get(`/contacts?search=${encodeURIComponent(searchQuery)}`))
}
export const fetchUsers = () => {
  return useApi(http.get(`/users`))
}
